module.exports = __webpack_public_path__ + "static/flags/VT-62a32b79a4c972b51bbf87619a869d42.gif";